export class UI{
    setUp(e){
        this.e = e;
    }

    load(){
        this.isLoaded_UI=true;
        
    }
    update(){
        
    }
}